module.exports = __webpack_public_path__ + "img/VF-mini.9b6de9f5.jpg";